import styled from '@emotion/styled';
import FilteredResults from './filtered-results';
import { ButtonGroup } from '@mui/material';
import NewActivityFilterButton from './new-activity-filter-button';
import NewFormatFilterButton from './new-format-filter-button';
import NewTimeFilterButton from './new-time-filter-button';

const ExploreContentDiv = styled.div`
  padding-left: 10%;
  padding-right: 10%;
  margin: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  @media (max-width: 768px) {
    padding-left: 0;
    position: relative;
    justify-content: flex-start;
  }
`;

const ButtonDiv = styled.div`
  width: 100%;
  height: auto;
  @media (max-width: 768px) {
    margin-bottom: 0px;
    padding: 0px;
  }
`;

const StyledButtonGroup = styled(ButtonGroup)`
  @media (max-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    row-gap: 16px;
    position: relative;
    margin-bottom: 24px;
  }
`;

const ButtonPaddingSmall = styled.div`
  padding-bottom: 24px;
  @media (max-width: 768px) {
    padding-bottom: 0px;
  }
`;

const ExploreContent = () => {
  return (
    <ExploreContentDiv>
      <ButtonDiv>
        <StyledButtonGroup>
          <NewActivityFilterButton />
          <NewFormatFilterButton />
          <NewTimeFilterButton />
        </StyledButtonGroup>
        <ButtonPaddingSmall />
      </ButtonDiv>
      <FilteredResults />
    </ExploreContentDiv>
  );
};
export default ExploreContent;
